import api from './api';

const channelService = {
  // Get all channels for the current user
  getChannels: async () => {
    try {
      const response = await api.get('/channels');
      return response.data;
    } catch (error) {
      console.error('Error getting channels:', error);
      throw error;
    }
  },

  // Get a specific channel
  getChannel: async (id) => {
    try {
      const response = await api.get(`/channels/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error getting channel ${id}:`, error);
      throw error;
    }
  },

  // Create a new channel
  createChannel: async (channelData) => {
    try {
      const response = await api.post('/channels', channelData);
      return response.data;
    } catch (error) {
      console.error('Error creating channel:', error);
      throw error;
    }
  },

  // Update a channel
  updateChannel: async (id, channelData) => {
    try {
      const response = await api.put(`/channels/${id}`, channelData);
      return response.data;
    } catch (error) {
      console.error(`Error updating channel ${id}:`, error);
      throw error;
    }
  },

  // Delete a channel
  deleteChannel: async (id) => {
    try {
      await api.delete(`/channels/${id}`);
      return true;
    } catch (error) {
      console.error(`Error deleting channel ${id}:`, error);
      throw error;
    }
  },

  // Get public profile with channels
  getPublicProfile: async (username) => {
    try {
      const response = await api.get(`/u/${username}`);
      return response.data;
    } catch (error) {
      console.error(`Error getting public profile for ${username}:`, error);
      throw error;
    }
  },
  
  // Fetch channel information from URL
  fetchChannelInfo: async (url) => {
    try {
      const response = await api.get(`/bot/fetch-info?url=${encodeURIComponent(url)}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching channel info:', error);
      throw error;
    }
  },
  
  // Resync channel information from Telegram
  resyncChannel: async (id) => {
    try {
      const response = await api.post(`/channels/${id}/resync`);
      return response.data;
    } catch (error) {
      console.error(`Error resyncing channel ${id}:`, error);
      throw error;
    }
  }
};

export default channelService; 